






















































import {
  defineComponent,
  ref,
  inject,
  computed,
  onMounted
} from '@vue/composition-api'
import Loader from '@/contexts/frontend/Loader.vue'
import { ConversationsApiKey, Logs } from '@/rest/conversations-api'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faPencilAlt,
  faTrashAlt,
  faSearch,
  faTimes,
  faSyncAlt,
  faInfoCircle,
  faCheckCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faQuestionCircle
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faPencilAlt,
  faTrashAlt,
  faSearch,
  faTimes,
  faSyncAlt,
  faInfoCircle,
  faCheckCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faQuestionCircle
)

import { noticeablyAsync, periodically } from '@/lib/async'

export default defineComponent({
  components: {
    loader: Loader
  },

  props: {
    conversationId: String
  },

  setup(props) {
    const logs = ref([] as Logs)
    const loading = ref(true)
    const conversationsApi = inject(ConversationsApiKey)

    const formatTime = (time: string) =>
      new Date(Date.parse(time)).toUTCString()
    const formatLevel = (level: string) => level.toLowerCase()

    const levelIcons = {
      info: 'info-circle',
      success: 'check-circle',
      warning: 'exclamation-triangle',
      error: 'exclamation-circle',
      debug: 'question-circle'
    }

    const levelColors = {
      info: 'blue',
      success: 'green',
      warning: 'orange',
      error: 'red',
      debug: 'gray'
    }

    const levelIcon = (level: string) =>
      levelIcons?.[level.toLowerCase()] ?? level

    const levelColor = (level: string) =>
      levelColors?.[level.toLowerCase()] ?? 'black'

    const noticeablyListLogs = noticeablyAsync(() =>
      conversationsApi.ListLogs(parseInt(props.conversationId))
    )

    const loadLogs = async () => {
      loading.value = true
      const response = await noticeablyListLogs()
      if (response?._tag == 'success') {
        logs.value = response.data.map(logEntry => ({
          time: formatTime(logEntry.time),
          level: formatLevel(logEntry.level),
          icon: levelIcon(logEntry.level),
          color: levelColor(logEntry.level),
          message: logEntry.message
        }))
      } else {
        //console.error(response.error)
      }
      loading.value = false
    }
    onMounted(loadLogs)

    const logEntriesFound = computed(() => logs.value.length > 0)

    return {
      logs,
      loading,
      logEntriesFound,
      loadLogs
    }
  }
})
